import InvoiceListPreliminary from "./Preliminary";

import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";

export default class InvoiceListForPayment extends InvoiceListPreliminary {
    constructor(props) {
        super(props);

        this.isPerMode = false;

        this.tableMap = {
            /*check: {
                type: "check",
                click: this.clickCheck.bind(this),
                cantSort: true,
            },*/
            openIcon: this.openIcon,
            createdTime: {
                label: "client.date",
                type: "dateTime",
                useTz: true,
            },
            invoiceNumber: {
                /*label: "invoice.billNumber",
                type: "object",
                valueFormat: "${invoiceId}/${clientId}",*/
                callback: this.formNumber.bind(this),
            },
            visit: {
                label: "client.visit",
                callback: this.visitCell.bind(this),
            },
            titleStage: {
                label: "main.stage",
                callback: this.stageCell.bind(this),
                cantSort: true,
            },
            teeth: {
                label: "client.teeth",
                type: "teeth",
                cantSort: true,
            },
            domainId: {
                label: "login.clinic",
                type: "select",
                store: "clinics",
                nameKey: "name",
            },
            totalSum: {
                label: "main.sum",
                type: "sum",
            },
            paidSum: {
                label: "client.duty",
                callback: this.dutyCell.bind(this),
            },
            /*actions: this.actionsProps,*/
            actions: {
                label: "main.actions",
                type: "actions",
                callback: this.renderInCell.bind(this),
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
        };

        this.textGroup = "Вы выбрали счета на оплату";
    }

    componentDidUpdate() {
        super.componentDidUpdate();

        this.setTotals();
    }

    async printWarrantyInvoice(info) {
        this._helper.showLoading();
        const resp = await this._request.accountHistory.getAllForInvoice(info.id);
        this._helper.hideLoading();

        this._print.warrantyInvoice({ ...info, accountHistory: (resp?.data || []) });
    }

    printAct(info) {
        this._print.act(info);
    }

    printActEmpty(info) {
        this._print.actEmpty(info);
    }

    renderInCell(value, map, info) {
        const actionsItems = [];
        const { status, domainId, comment, id, clientId, createdTime, doctorId, paidSum } = info;

        if (status !== "PAID" && status !== "CANCELLED") {
            actionsItems.push({ name: "main.edit", onClick: this.openInvoiceEditor.bind(this, info) });
        }

        if (!((status === "PAID" && (this._helper.isDoctor() || this._helper.isAssistant())) || status === "CANCELLED")) {
            actionsItems.push({ name: "invoice.cancel", onClick: this.props.removeInvoice.bind(this, info) });
            actionsItems.push({ line: true });
        }

        const title = `${id}/${clientId} от ${this._helper.date.toStr(new Date(createdTime), "DD.MM.YYYY")}`;
        const fio = this._helper.string.formatFullName(this.props.info);
        const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId));
        const clinics = this._helper.getClinics();
        const clinic = clinics.find(infoClinic => infoClinic.id === domainId);
        const { profileNumber, createdTime: dateRegistration, clientBalance, birthday, totalSum: ts, totalPaidSum } = this.props.info;
        const debt = ts - totalPaidSum;
        const infoPrint = {
            ...info, profileNumber, dateRegistration, clientBalance, birthday, ts, totalPaidSum, clinic, comment,
            fio, doctor, title, debt, paidSum, createdTime
        };

        /*actionsItems.push({ name: "main.print", onClick: this.props.printInvoice.bind(this, "Warranty_invoice", info) });
        actionsItems.push({ name: "invoice.printAct", onClick: this.props.printInvoice.bind(this, "Act_of_acceptance", info) });
        actionsItems.push({ name: "invoice.printActEmpty", onClick: this.props.printInvoice.bind(this, "act_of_acceptance_no_domain", info) });*/
        if (status !== "CANCELLED") {
            actionsItems.push({ name: "main.print", onClick: this.printWarrantyInvoice.bind(this, infoPrint) });
            actionsItems.push({ name: "invoice.printAct", onClick: this.printAct.bind(this, infoPrint) });
            actionsItems.push({ name: "invoice.printActEmpty", onClick: this.printActEmpty.bind(this, infoPrint) });
        }

        return (actionsItems?.length ? <ButtonIconSelect
            translate={true}
            items={actionsItems}
        /> : false);
    }

    stageCell(value) {
        return (
            <>
                <div>{value ? value : false}</div>
            </>
        );
    }

    formNumber(value, it, { id, clientId }) {
        return `${id}/${clientId}`;
    }

    openInvoiceEditor(info) {
        const { /*invoiceNumber,*/ paidSum } = info;
        //const { invoiceId, clientId } = invoiceNumber || {};

        const number = `${info.id}/${info.clientId}`;
        const sum = this._helper.number.toSum(paidSum || 0);
        const message = this.tr("invoice.changeInvoiceMessage").replace("$1", number).replace("$2", sum);

        this._helper.confirm({ title: "invoice.changeInvoice", message }, this.props.openInvoiceEditor.bind(this, info));
    }

    setTotals() {
        const { info } = this.props;
        const duty = this.totalSum - this.totalPaidSum;

        this.totalNode.innerHTML = this._helper.number.toSum(this.totalSum);
        this.totalPaidNode.innerHTML = this._helper.number.toSum(this.totalPaidSum);
        this.dutyNode.innerHTML = this._helper.number.toSum(duty);
        this.balance.innerHTML = this._helper.number.toSum(info.clientBalance.balance);

        this._helper.dom.addRemoveClass(this.dutyNode, "red", duty > 0);
    }

    dutyCell(paidSum, props, info) {
        const { totalSum, status } = info;
        let cl = "";

        if (status === "CANCELLED")
            return null;

        this.totalSum += totalSum;
        this.totalPaidSum += paidSum;

        cl = "duty";

        const value = totalSum - paidSum;
        const sum = this._helper.number.toSum(value);

        if (value < 1)
            return sum;

        return (
            <div className="flex centerV between gap32">
                <div className={cl}>{sum}</div>
                <Button
                    type="secondary"
                    label="invoice.pay"
                    size="small"
                    onClick={this.checkClinicBeforePayment.bind(this, info)}
                />
            </div>
        );
    }

    visitCell(info) {
        if (!info?.beginDate)
            return "";

        const { beginDate, endDate } = info;

        return this._helper.date.toPeriodStr(beginDate, endDate);
    }

    checkClinicBeforePayment(info, e) {
        this._helper.stopEvent(e);

        if (info.domainId !== this.props.clinicId) {
            this._helper.confirm(
                { title: "Расхождение данных", message: this.tr(" Внимание! Вы оплачиваете счет с другой клиники! - Подтвердить?") },
                this.openPayDialog.bind(this, info)
            );
        } else
            this.openPayDialog(info);
    }

    openPayDialog(info) {
        info.invoiceNumber = {
            clientId: info.clientId,
            invoiceId: info.id
        };
        info.mistyClient = this.props.info.mistyClient;

        this._helper.openDialog("billPayment", this.props.info.balance, info, data => {
            this.props.addPayHistory(data, this._helper.showNotify.bind(this._helper, "main.payment", "invoice.paidSuccess"));
        });
    }

    insertBillItem(sum, text, key, isDuty) {
        return (
            <div className="flex centerV gap8 billItem">
                <div className="label text p1">{this.tr(text)}</div>
                <div ref={el => this[key] = el} className="price text p1SemiBold">{this._helper.number.toSum(sum)}</div>
            </div>
        );
    }

    beforeRender() {
        this.totalSum = 0;
        this.totalPaidSum = 0;
    }

    renderLeftActions() {
        return (
            <div className="flex gap16">
                {this.insertBillItem(0, "invoice.allBills", "totalNode")}
                {this.insertBillItem(0, "invoice.paidBills", "totalPaidNode")}
                {this.insertBillItem(0, "client.duty", "dutyNode")}
                {this.insertBillItem(0, "invoice.balance", "balance")}
            </div>
        );
    }
}
